import {AnimatePresence, motion} from 'framer-motion';

type AnimatedNumberProps = {
    value: number;
    size?: 'sm' | 'md' | 'lg';
    fontSize?: number;
};

export const AnimatedNumber = ({
    value,
    size = 'lg',
    fontSize,
}: AnimatedNumberProps) => {
    const fontSizeStyle = {
        sm: {
            fontSize: '1.5rem',
        },
        md: {
            fontSize: '2rem',
        },
        lg: {
            fontSize: '3rem',
        },
    };
    return (
        <div
            className="inline-flex items-center justify-center"
            style={{
                perspective: '1000px',
                justifyContent: 'center',
                width: '1.1em',
                height: '1.2em',
                borderRadius: '10px',
                overflow: 'hidden',
                ...fontSizeStyle[size],
                fontSize: fontSize,
            }}>
            <div
                style={{
                    position: 'relative',
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    overflow: 'hidden',
                }}>
                <AnimatePresence initial={false}>
                    <motion.div
                        className="font-mono"
                        key={value}
                        initial={{y: '-100%'}}
                        animate={{y: 0}}
                        exit={{y: '100%'}}
                        transition={{duration: 0.2}}
                        style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            width: '100%',
                            height: '100%',
                            position: 'absolute',
                            top: 0,
                        }}>
                        {value}
                    </motion.div>
                </AnimatePresence>
            </div>
        </div>
    );
};
